import { Reducer } from "redux";

import { ReAuthDefaultValueResponse } from "../models/api/Patient";
import { ReAuthDefaultValueDispatchTypes } from "../models/dispatchTypes/Patient";
import { ReAuthDefaultValueActionDispatchTypes } from "../constants/Patient";

const initialState: ReAuthDefaultValueResponse = {
  loading: false,
  response: {
    referralId: 0,
    authorizationNumber: "",
    referralStatusName: "",
    minEffectiveFromDate: "",
    maxEffectiveThroughDate: "",
    sn: 0,
    pt: 0,
    ot: 0,
    st: 0,
    msw: 0,
    hha: 1,
    lastName: "",
    firstName: "",
    dateOfBirth: "",
    gender: "",
    medicareBeneficiaryIdentifier: "",
    patientId: 0,
    totalRows: 0,
    authorizationTypeName: "",
    providerId: 0,
    subscriberId: "",
    reimbursementTypeId: 0,
    reimbursementTypeName: "",
    benefitPlan: "",
  },
  error: null,
};

const SetDefaultReAuthValuesReducer: Reducer<
  ReAuthDefaultValueResponse,
  ReAuthDefaultValueDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ReAuthDefaultValueActionDispatchTypes.RE_AUTH_DEFAULT_INFO_ELIGIBILITY_CHECK_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ReAuthDefaultValueActionDispatchTypes.RE_AUTH_DEFAULT_INFO_ELIGIBILITY_CHECK_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case ReAuthDefaultValueActionDispatchTypes.RE_AUTH_DEFAULT_INFO_ELIGIBILITY_CHECK_ERRORS: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case ReAuthDefaultValueActionDispatchTypes.RE_AUTH_DEFAULT_INFO_ELIGIBILITY_CHECK_RESET: {
      return initialState;
    }
  }
  return state;
};

export default SetDefaultReAuthValuesReducer;
